import { helpers } from "vuelidate/lib/validators";

export const faxValidator = helpers.regex(
  "faxValidator",
  /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)\.]*$/m
);